import { ValueObject } from "@singularsystems/neo-core";

export default class BaseCheckQueryCommand extends ValueObject {
    public checkQueryCode: string = "";

    public checkQueryDescription: string = "";

    public storedProcedureName: string = "";

    public tierId: number | null = null;
}